module.exports = __webpack_public_path__ + "static/img/static-zoom-in2.06d09ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static-zoom-in2.png
// module id = 76
// module chunks = 0